import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { stepperStoreCreator, type StepperStore } from './creator'

export const useStepperStore = create<StepperStore>()(
  persist(stepperStoreCreator, {
    name: '@SwileCorporates:Stepper',
    storage: createJSONStorage(() => sessionStorage)
  })
)
